import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  FETCH_WORKFLOW_STATUS_LIST,
  UPDATE_WORKFLOW_STATUS_LIST,
  updateWorkFlowStatusListSuccess,
  updateWorkFlowStatusListFail,
  fetchWorkFlowStatusListSuccess,
  fetchWorkFlowStatusListFail,
  FETCH_ALERT_LEVEL,
  UPDATE_ALERT_LEVEL,
  fetchAlertLevelSuccess,
  fetchAlertLevelFail,
  fetchWorkFlowStatusList as fetchWorkFlowStatusListActions,
  updateAlertLevelSuccess,
  fetchAlertLevel,
  updateAlertLevelFail
} from '../../redux/actions/cm/workFlowStatus';
import {
  fetchAlertLevelList,
  fetchWorkFlowStatusList,
  updateAlertLevel as updateAlertLevelService,
  updateWorkFlowStatusList
} from '../../services/cm/workFlowStatus';
import { Modal } from 'antd';
import { reloadAlerts } from '../../redux/actions/cm/alertList';
import { reloadCases } from '../../redux/actions/cm/caseList';
import { fetchAMLSAlertLevel } from '../../redux/actions/common';

export function* fetchAlertLevelWorker() {
  try {
    const alertLevels = yield call(fetchAlertLevelList);
    yield put(fetchAlertLevelSuccess(alertLevels));
  } catch (error) {
    yield put(fetchAlertLevelFail(error));
  }
}

export function* fetchWorkFlowStatusListWorker() {
  try {
    const workFlowStatuses = yield call(fetchWorkFlowStatusList);
    const modifiedWorkFlowStatuses = workFlowStatuses.workflowStatus.map(
      (status) => ({
        ...status,
        dynamicValue: status.currentValue
      })
    );
    yield put(fetchWorkFlowStatusListSuccess(modifiedWorkFlowStatuses));
  } catch (error) {
    yield put(fetchWorkFlowStatusListFail(error));
  }
}

function* updateWorkFlowStatusListWorker({ statusList }) {
  try {
    yield call(updateWorkFlowStatusList, { statusList });
    yield put(updateWorkFlowStatusListSuccess());
    yield put(fetchWorkFlowStatusListActions());

    Modal.success({
      title: 'Success',
      content: 'Status names updated successfully'
    });
  } catch (error) {
    yield put(updateWorkFlowStatusListFail(error));
  }
}

export function* updateAlertLevelWorker({ updatedAlertLevels }) {
  try {
    yield call(updateAlertLevelService, { updatedAlertLevels });
    yield put(updateAlertLevelSuccess());
    yield put(fetchAlertLevel());
    // FIN-12809: the level config lives in two independent stores — this settings screen reads
    // `cm/workFlowStatus` (refreshed above), while the Hit Level filter on the screening alert
    // details page reads `common -> amlsCommon.alertLevelConfigs`. Only refreshing the first left
    // that dropdown showing the pre-edit names for the rest of the session, since the alert page
    // only fetches when its copy is empty. Invalidate both.
    yield put(fetchAMLSAlertLevel());
    yield put(reloadAlerts());
    yield put(reloadCases());

    Modal.success({
      title: 'Success',
      content: 'Alert level names updated successfully'
    });
  } catch (error) {
    yield put(updateAlertLevelFail(error));
  }
}

export function* watchFetchAlertLevel() {
  yield takeEvery(FETCH_ALERT_LEVEL, function* () {
    yield fork(fetchAlertLevelWorker);
  });
}

export function* watchFetchWorkFlowStatusList() {
  yield takeEvery(FETCH_WORKFLOW_STATUS_LIST, function* () {
    yield fork(fetchWorkFlowStatusListWorker);
  });
}

export function* watchUpdateAlertLevel() {
  yield takeEvery(
    UPDATE_ALERT_LEVEL,
    function* ({ payload: updatedAlertLevels }) {
      yield fork(updateAlertLevelWorker, { updatedAlertLevels });
    }
  );
}

export function* watchUpdateWorkFlowStatusList() {
  yield takeEvery(
    UPDATE_WORKFLOW_STATUS_LIST,
    function* ({ payload: statusList }) {
      yield fork(updateWorkFlowStatusListWorker, { statusList });
    }
  );
}
